/**
 * Chunk load recovery
 *
 * CRA code-splitting uses hashed chunk filenames. If a user has an older main bundle
 * cached (or deploy is not atomic), a lazy-loaded chunk request can 404 and return
 * HTML, causing:
 * - "ChunkLoadError: Loading chunk X failed"
 * - "Uncaught SyntaxError: Unexpected token '<'"
 *
 * This registers global handlers to reload the page ONCE per session when we detect
 * a chunk-load failure. This is a pragmatic, user-friendly fix.
 */

const RELOAD_KEY = 'neev_chunk_reload_once_v1';

function shouldReloadOnce() {
  try {
    return sessionStorage.getItem(RELOAD_KEY) !== '1';
  } catch {
    return true;
  }
}

function markReloaded() {
  try {
    sessionStorage.setItem(RELOAD_KEY, '1');
  } catch {
    // ignore
  }
}

function isChunkLoadError(err) {
  const msg = String(err?.message || err || '');
  return (
    err?.name === 'ChunkLoadError' ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Loading chunk') ||
    msg.includes('Unexpected token \'<\'') ||
    // Safari / some bundlers
    msg.includes('Importing a module script failed')
  );
}

function triggerReload() {
  if (!shouldReloadOnce()) return;
  markReloaded();
  // Force a refresh so we fetch the latest index.html + main bundle.
  window.location.reload();
}

export function registerChunkLoadRecovery() {
  // 1) Script error event (covers some chunk failures)
  window.addEventListener('error', (event) => {
    // event.error is not always present (cross-origin script errors), so check message too
    const err = event?.error || event?.message;
    if (isChunkLoadError(err)) triggerReload();
  });

  // 2) Promise rejection (covers dynamic import / React.lazy chunk failures)
  window.addEventListener('unhandledrejection', (event) => {
    const err = event?.reason;
    if (isChunkLoadError(err)) triggerReload();
  });
}


